// extracted by mini-css-extract-plugin
export default {"tableMainElem":"Contracts_tableMainElem__-YtRS","viewMainElem":"Contracts_viewMainElem__YK1BX"};